// extracted by mini-css-extract-plugin
export default {"centerButton":"OneMonthSlide_centerButton__Hfv-m","description":"OneMonthSlide_description__EjPEs"};